import { env } from '@/env';
import { useHasLogtoRole } from '@/hooks/useHasLogtoRole';
import { limuloIsTheSource } from '@/lib/limulo/sorgente';

/**
 * `true` quando il flag di Limulo e il ruolo `beta` sono entrambi accesi: la fonte dell'account
 * di gioco e' Limulo. Il predicato e' in `lib/limulo/sorgente.ts` — non riscriverlo qui.
 */
export function useLimuloIsTheSource(): boolean {
  const isBeta = useHasLogtoRole('beta');
  return limuloIsTheSource(env.featureLimuloEnabled, isBeta);
}
